import React, { useState, useEffect, useCallback } from "react";
import { useSelector, useDispatch } from "react-redux";
import { FilterList, Add, ViewColumn } from "@material-ui/icons";
import { useHistory } from "react-router-dom";
import { IconButton, useTheme, Menu, MenuItem, Checkbox, FormControlLabel, Tooltip, Badge,Button } from "@material-ui/core";

import MoreVertIcon from "@material-ui/icons/MoreVert";
import CloseIcon from "@material-ui/icons/Close";
import SettingsIcon from '@material-ui/icons/Settings';
import CloudUpload from "@material-ui/icons/CloudUpload";


import { getFilterConfig, getListView, } from "../../../../store/actions/module.actions";
import { getEmailCreateView } from "../../../../store/actions/emails.actions";
// import { ImportFileModal } from "../CustomToolbarSelect/components"
import { Filter, ImportFile, ColumnChooser } from "./components";
import { QuickComposeEmail } from "../../../Emails/components";
import useStyles from "./styles";
import { getMuiTheme } from "./styles";
import { MuiThemeProvider } from "@material-ui/core/styles";
import { pathOr } from "ramda";
import EmailSettings from "../../../Emails/components/EmailSettings";

const CustomToolbar = ({ selectAll, handleSelectAllChange, selectedRecordLength, emailModal }) => {

  const [emailModalVisible, setEmailModalVisible] = useState(emailModal && emailModal.visible ? emailModal.visible : false);
  const [modalVisible, setModalVisibility] = useState(false);
  const [emailSettingModal, setEmailSettingModal] = useState(false);
  const [importModalVisible, setImportModalVisible] = useState(false);
  const [columnChooserVisible, setColumnChooserVisibility] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [filterQuery, setFilterQuery] = useState(null);


  const [filterQueryMeta, setFilterQueryMeta] = useState(null);
  const { emailCreateViewLoading } = useSelector((state) => state.emails);


  const history = useHistory();
  const classes = useStyles();
  const currentTheme = useTheme();

  const {
    selectedModule,
    listViewTabData,
    filterConfigLoading,
    filterConfigError,
    filterConfig,
  } = useSelector((state) => state.modules);
  const where = pathOr({}, ['data', 'templateMeta', 'where'], listViewTabData[selectedModule]);
  const sort = pathOr({}, ['data', 'templateMeta', 'sort'], listViewTabData[selectedModule]);
  const filterParams = pathOr([], ['templateMeta', 'data', 'advanced_search'], filterConfig[selectedModule]);
  const config = useSelector((state) => state.config);
  const rowsPerPage = pathOr(20, ['config', 'list_max_entries_per_page'], config);

  const dispatch = useDispatch();

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };


  const fetchFilterConfig = useCallback(() => {
    if (selectedModule) {
      dispatch(getFilterConfig(selectedModule));
    }
  }, [dispatch, selectedModule]);

  useEffect(() => { fetchFilterConfig(); setFilterQuery(null); }, [fetchFilterConfig, selectedModule]);
  //useEffect(() => { if(!filterConfig){fetchFilterConfig(); setFilterQuery(null);} }, [fetchFilterConfig, selectedModule]);
  useEffect(() => { if (emailModal.visible === true) { dispatch(getEmailCreateView()); setEmailModalVisible(emailModal.visible); } }, [emailModal]);


  const searchFilter = (query, isReset) => {
    if (isReset) {
      setFilterQuery(null);
      setFilterQueryMeta(null);
      
    }
    dispatch(getListView(selectedModule, 0, rowsPerPage, sort, query)).then(function (res) {
      dispatch(getFilterConfig(selectedModule));
   
    });
    if (!isReset) {
      setModalVisibility(!modalVisible);
      
    }
  }
  const filteredParams = () => {
    let optionsToRender = [];
    filterParams.map((fieldsMeta, key) => {
      let value = Array.isArray(fieldsMeta.value) ? fieldsMeta.value.toString() : fieldsMeta.value;
      if (value) {
        if(fieldsMeta.type === "multienum")
        {
          const fieldsMetaOptions = Object.keys(pathOr([], ['value'], fieldsMeta));
          let FrontString = [];
          fieldsMetaOptions.map((fieldsMeta1, key1) => {
            FrontString.push(fieldsMeta.options[fieldsMeta.value[fieldsMeta1]]);
          });
          value = FrontString.toString();
          optionsToRender.push(<div><p>{fieldsMeta.label} : {fieldsMeta.type === 'datetime' || fieldsMeta.type === 'datetimecombo' ? fieldsMeta.options[value] : fieldsMeta.type === 'relate'?value.value:value}{fieldsMeta['range_' + fieldsMeta.name] ? "=" + fieldsMeta['range_' + fieldsMeta.name] : ''}
          {fieldsMeta['start_range_' + fieldsMeta.name] ? " " + fieldsMeta['start_range_' + fieldsMeta.name] + " to " : ''}{fieldsMeta['end_range_' + fieldsMeta.name] ? fieldsMeta['end_range_' + fieldsMeta.name] : ''}</p></div>);
        } 
        else
        {
          optionsToRender.push(<div><p>{fieldsMeta.label} : {fieldsMeta.type === 'datetime' || fieldsMeta.type === 'datetimecombo' ? fieldsMeta.options[value] : fieldsMeta.type === 'relate'?value.value:value}{fieldsMeta['range_' + fieldsMeta.name] ? "=" + fieldsMeta['range_' + fieldsMeta.name] : ''}
          {fieldsMeta['start_range_' + fieldsMeta.name] ? " " + fieldsMeta['start_range_' + fieldsMeta.name] + " to " : ''}{fieldsMeta['end_range_' + fieldsMeta.name] ? fieldsMeta['end_range_' + fieldsMeta.name] : ''}</p></div>);
        }
      }
    });
    if (!optionsToRender.length)
      return '';
    return optionsToRender;
  };

  return (
    <MuiThemeProvider theme={getMuiTheme(currentTheme)}>

      {importModalVisible && (
        <ImportFile
        module={selectedModule}
          visible={importModalVisible}
          toggleVisibility={() => setImportModalVisible(!importModalVisible)}
        />
      )}
      {columnChooserVisible && (
        <ColumnChooser
          modalVisible={columnChooserVisible}
          toggleModalVisibility={() => setColumnChooserVisibility(!columnChooserVisible)}
        />
      )}
      <div className={classes.container}>
        {(selectedModule !== 'Emails') ?
          ((selectedModule !== 'AOR_Reports') && <span className={classes.optionWrapper} onClick={() => history.push(`/app/createview/${selectedModule}`)}><Add /> Create</span>) :
          (<>
            <span className={classes.optionWrapper} onClick={() => { dispatch(getEmailCreateView()); setEmailModalVisible(!emailModalVisible); }}>
              <Add /> Compose
        </span>
            <span className={classes.optionWrapper} onClick={() => { setEmailSettingModal(true) }}>
              <SettingsIcon /> Setting
        </span>
          </>)
        }

        
        <span className={classes.optionWrapper} onClick={() => setImportModalVisible(!modalVisible)}>
           <CloudUpload />&nbsp;Import
        </span> 
       



        <span className={classes.optionWrapper} onClick={() => setModalVisibility(!modalVisible)}>
          <FilterList /> Filter
        </span>

        {
          filteredParams() && <Tooltip arrow title={filteredParams()}><span className={classes.optionWrapper} onClick={() => searchFilter(`filter[reset][eq]=true&`, true)}><CloseIcon />Clear Filter</span>
          </Tooltip>

        }


        <span
          className={classes.optionWrapper}
          onClick={(e) => {
            setColumnChooserVisibility(!columnChooserVisible)
          }}
        >
          <ViewColumn /> Columns
        </span>
        <span className={classes.optionWrapper} >
          <Badge badgeContent={selectedRecordLength} max={999} color="primary">
            <IconButton aria-label="settings" onClick={handleClick}>
              <MoreVertIcon />
            </IconButton>
          </Badge>

          <Menu
            id="openSelectAll"
            anchorEl={anchorEl}
            keepMounted
            open={Boolean(anchorEl)}
            onClose={handleClose}
          >
            <MenuItem >
              {selectAll ?
                <FormControlLabel
                  control={<Checkbox checked={selectAll} onChange={handleSelectAllChange} name="selectAllOption" />}
                  label="Deselect All"
                /> : <FormControlLabel
                  control={<Checkbox checked={selectAll} onChange={handleSelectAllChange} name="selectAllOption" />}
                  label={"Select All"}
                />}
            </MenuItem>

          </Menu>
        </span>

      </div>


      {modalVisible?<Filter
        modalState={modalVisible}
        handleClose={() => setModalVisibility(!modalVisible)}
        loading={filterConfigLoading}
        error={filterConfigError}
        config={filterConfig[selectedModule]}
        search={(query, isReset) => searchFilter(query, isReset)}
        setFilterQuery={(query) => setFilterQuery(query)}
        setFilterQueryMeta={(query) => setFilterQueryMeta(query)}
        selectedModule={selectedModule}
      />:null}
      <EmailSettings
        open={emailSettingModal}
        handleClose={() => setEmailSettingModal(!emailSettingModal)}
      />
      {
        emailModalVisible && !emailCreateViewLoading ? (<QuickComposeEmail
          modalState={emailModalVisible}
          to_addrs_names={(emailModal && emailModal.to) ? emailModal.to : ''}
          parent_name={(emailModal && emailModal.parent_name) ? emailModal.parent_name : ''}

          handleClose={() => { setEmailModalVisible(!emailModalVisible); }}
        />) : ""
      }

    </MuiThemeProvider>
  );
};

export default CustomToolbar;